import { NormApi } from './norm'
import {
  IExternalDataColumn,
  IExternalDataMembersParams,
  IExternalDataListParams,
} from '@/utils/types'

export class ExternalDataApi extends NormApi<IExternalDataColumn> {
  getColumns = async (app_id: string) => {
    const response = await this.axios.get('/v1/external-data/columns', {
      params: { app_id },
    })
    return this.responseHandler(response)
  }

  getMembers = async (params: IExternalDataMembersParams) => {
    const response = await this.axios.get('/v1/external-data/members', {
      params,
    })
    return this.responseHandler(response)
  }

  listFiles = async (payload: IExternalDataListParams) => {
    const response = await this.axios.post('/v1/external-data/list', payload)
    return this.responseHandler(response)
  }
}

const externalDataApi = new ExternalDataApi()
export default externalDataApi
